/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PhotoModel } from '../../models/photo-model';

export interface AdminPersonIdPhotoPost$Params {
  personId: string;
      body?: PhotoModel
}

export function adminPersonIdPhotoPost(http: HttpClient, rootUrl: string, params: AdminPersonIdPhotoPost$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminPersonIdPhotoPost.PATH, 'post');
  if (params) {
    rb.path('personId', params.personId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<string>;
    })
  );
}

adminPersonIdPhotoPost.PATH = '/Admin/{personId}/Photo';
